<template>
  <div class="pa-6 bg-custom">
    <h2 class="mb-4">
      {{ $vuetify.lang.t('$vuetify.courseManagement.stepCourse.certificate') }}
    </h2>

    <v-form ref="form" v-model="valid" v-on:submit.prevent="onUpload">
      <v-sheet color="white" class="mb-6 pa-6">
        <v-row no-gutters class="mb-3">
          <v-col class="body-1 font-weight-medium text-custom-title">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.certificateOption'
              )
            }}
            <span class="red--text">*</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-radio-group v-model="certificate" row class="mt-0" hide-details="">
            <v-radio
              :label="
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.noCertificate'
                )
              "
              :value="false"
            ></v-radio>
            <v-radio
              :label="
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.yesCertificate'
                )
              "
              :value="true"
            ></v-radio>
          </v-radio-group>
        </v-row>
      </v-sheet>

      <v-sheet color="white" class="mb-6 pa-6" v-show="certificate">
        <v-row no-gutters class="mb-3">
          <v-col class="body-1 font-weight-medium text-custom-title">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.setPercent'
              )
            }}
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-text-field
            outlined
            type="number"
            @change="checkMinPercentScore"
            :disabled="!certificate"
            v-model="percentCertificate"
            class="body-1 mr-2"
            min="0"
            max="100"
            background-color="white"
            style="max-width: 110px"
            hide-details
          ></v-text-field>
          <div class="body-1 font-weight-medium text-custom-title">%</div>
        </v-row>
        <div class="body-2 pt-3">
                  <v-icon color="info">mdi-information-outline</v-icon>
                {{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.setPercentDetail1') }}
                {{ percentCertificate }} % 
                {{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.setPercentDetail2') }}
        </div>
      </v-sheet>

      <v-row v-show="certificate">
        <v-col xl="4" lg="5" md="5" cols="5">
          <v-card elevation="0" width="100%" class="pb-3" tile>
            <!-- <p>
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.certificateStyle'
                )
              }}
            </p> -->

            <v-tabs v-model="certificateSelectedItem" show-arrows grow>
              <!-- <v-tab
                class="uppercast-unset"
                v-for="item in certificateStyleItems"
                :key="item"
              >
                {{ item }}
              </v-tab> -->
              <v-tab href="#background" class="subtitle-1 uppercast-unset">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.background'
                )
              }}</v-tab>
              <v-tab href="#learner" class="subtitle-1 uppercast-unset">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.studentName'
                )
              }}</v-tab>
              <v-tab href="#courseName" class="subtitle-1 uppercast-unset">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.courseName'
                )
              }}</v-tab>
              <v-tab href="#issuedDate" class="subtitle-1 uppercast-unset">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.issuedDate'
                )
              }}</v-tab>
              <v-tab
                href="#expirationDate"
                class="subtitle-1 uppercast-unset"
                >{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.certificateStep.expDate'
                  )
                }}</v-tab
              >
              <v-tab-item value="background">
                <v-row>
                  <v-col cols="12" class="mt-3" align="center">
                    <div v-if="imgPreview2" class="image-preview border-card">
                      <v-img
                        contain
                        :src="imgPreview2"
                        aspect-ratio="1"
                        width="100%"
                        height="100%"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                    <div
                      v-if="!imgPreview2"
                      class="image-preview border-card"
                    ></div>
                    <div class="upload-btn-wrapper mt-3">
                      <button class="btn-choose body-1 font-weight-light">
                        <v-icon>mdi-upload</v-icon
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.chooseImage'
                          )
                        }}
                      </button>
                      <input
                        type="file"
                        @change="preview2"
                        accept="image/png, image/jpeg, image/bmp"
                      />
                    </div>
                    <p class="mb-0 text-custom body-2 font-weight-regular">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.certificateStep.acceptBackgroundFormat'
                        )
                      }}
                    </p>
                    <p class="mb-0 text-custom body-2 font-weight-regular">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.certificateStep.maxFileSize'
                        )
                      }}
                      {{ this.imgMaxSize }}MB
                    </p>
                    <!-- <div v-show="imgPreview2 != ''">
                        <v-img
                          class="align-center"
                          contain
                          :src="imgPreview2"
                          height="150px"
                          width="150px"
                          style="
                            margin: 0 auto;
                            border-style: solid;
                            min-width: 150px;
                            min-height: 150px;
                            max-height: 150px;
                            max-width: 150px;
                          "
                        />
                      </div> -->

                    <!-- <div
                        v-show="imgPreview2 == ''"
                        class="centerContainer"
                        style="
                          color: black;
                          border-style: solid;
                          min-width: 150px;
                          min-height: 150px;
                          max-height: 150px;
                          max-width: 150px;
                        "
                      >
                        <div
                          class="text-custom-title centerDiv"
                          style="margin: 0 auto"
                        >
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.pleaseSelectOrUploadBackground'
                            )
                          }}
                        </div>
                      </div> -->
                  </v-col>
                </v-row>
                <v-row class="px-5">
                  <v-col cols="12">
                    <p class="mb-0 body-1 font-weight-black">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.certificateStep.backgroundTemplate'
                        )
                      }}
                    </p>
                  </v-col>
                </v-row>

                <v-row class="px-5 text-center">
                  <v-col
                    v-for="(item, index) in backgroundTemplateList"
                    :key="item"
                    cols="3"
                  >
                    <!-- <a v-if="item.use == true">
                      <v-badge color="green" icon="mdi-check" bordered overlap>
                        <v-avatar tile size="100">
                          <v-img
                            :src="item.image"
                            aspect-ratio="1"
                            height="100"
                            @change="setBackground(item, index)"
                          />
                        </v-avatar>
                      </v-badge>
                    </a> -->
                    <a>
                      <v-avatar tile size="95">
                        <v-img
                          :src="item.image"
                          aspect-ratio="1"
                          @click="setBackground(item, index)"
                        ></v-img>
                      </v-avatar>
                    </a>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="learner">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.studentName'
                          )
                        }}
                      </p>
                      <v-radio-group
                        hide-details
                        v-model="certificateStudentName"
                        row
                        @change="drawCertificate"
                      >
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.studentNameNo'
                            )
                          "
                          :value="false"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.studentNameYes'
                            )
                          "
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateStudentName">
                    <v-col cols="12">
                      <p class="mb-0">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textSize'
                          )
                        }}
                      </p>
                      <v-slider
                        v-model="studentFontSize"
                        class="align-center"
                        :max="maxFontSize"
                        :min="minFontSize"
                        hide-details
                        thumb-label
                        @change="drawCertificate"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="studentFontSize"
                            @change="drawCertificate"
                            class="mt-0 pt-0 textfield-custom-number"
                            hide-details
                            outlined
                            type="number"
                          >
                          </v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateStudentName">
                    <v-col cols="5">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textColor'
                          )
                        }}
                      </p>
                      <v-card
                        class="mx-auto"
                        max-width="400"
                        outlined
                        @click="openDialogStudentColor"
                      >
                        <v-list-item two-line>
                          <v-list-item-avatar tile>
                            <v-sheet
                              :color="studentNameColor"
                              elevation="0"
                              height="100"
                              width="100"
                            ></v-sheet>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-subtitle>{{
                              studentNameColor
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-col>
                  </v-row>

                  <div v-if="certificateStudentName">
                    <v-row>
                      <v-col cols="12">
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.textPosition'
                            )
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-slider
                        v-model="studentNameTop"
                        class="align-center custom-slider"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="studentNameTop"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.downUp'
                          )
                        }}
                      </div>
                    </v-row>
                    <v-row class="pt-2">
                      <v-slider
                        v-model="studentNameLeft"
                        class="align-center custom-slider"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="studentNameLeft"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.leftRight'
                          )
                        }}
                      </div>
                    </v-row>
                  </div>
                </v-card-text>
              </v-tab-item>
              <v-tab-item value="courseName">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.courseName'
                          )
                        }}
                      </p>
                      <v-radio-group
                        hide-details
                        v-model="certificateCourseName"
                        row
                        @change="drawCertificate"
                      >
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.courseNameNo'
                            )
                          "
                          :value="false"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.courseNameYes'
                            )
                          "
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateCourseName">
                    <v-col cols="12">
                      <p class="mb-0">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textSize'
                          )
                        }}
                      </p>
                      <v-slider
                        v-model="courseFontSize"
                        class="align-center"
                        :max="maxFontSize"
                        :min="minFontSize"
                        hide-details
                        thumb-label
                        @change="drawCertificate"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="courseFontSize"
                            @change="drawCertificate"
                            class="mt-0 pt-0 textfield-custom-number"
                            hide-details
                            outlined
                            type="number"
                          >
                          </v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateCourseName">
                    <v-col cols="5">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textColor'
                          )
                        }}
                      </p>
                      <v-card
                        class="mx-auto"
                        max-width="400"
                        outlined
                        @click="openDialogCourseColor"
                      >
                        <v-list-item two-line>
                          <v-list-item-avatar tile>
                            <v-sheet
                              :color="courseNameColor"
                              elevation="0"
                              height="100"
                              width="100"
                            ></v-sheet>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-subtitle>{{
                              courseNameColor
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-col>
                  </v-row>

                  <div v-if="certificateCourseName">
                    <v-row>
                      <v-col cols="12">
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.textPosition'
                            )
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-slider
                        v-model="courseNameTop"
                        class="align-center"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="courseNameTop"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.downUp'
                          )
                        }}
                      </div>
                    </v-row>
                    <v-row class="pt-2">
                      <v-slider
                        v-model="courseNameLeft"
                        class="align-center custom-slider"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="courseNameLeft"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.leftRight'
                          )
                        }}
                      </div>
                    </v-row>
                  </div>
                </v-card-text>
              </v-tab-item>
              <v-tab-item value="issuedDate">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.issuedDate'
                          )
                        }}
                      </p>
                      <v-radio-group
                        hide-details
                        v-model="certificateDate"
                        row
                        @change="drawCertificate"
                      >
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateNo'
                            )
                          "
                          :value="false"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateYes'
                            )
                          "
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateDate">
                    <v-col cols="12">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.dateDeliver'
                          )
                        }}
                      </p>
                      <v-radio-group
                        hide-details
                        v-model="certificateDateSetting"
                        row
                        @change="drawCertificate"
                      >
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateOptionAuto'
                            )
                          "
                          :value="false"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateOptionFixed'
                            )
                          "
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                      <p
                        v-if="certificateDateSetting == false"
                        class="font-weight-light subtitle-1 mt-3 grey--text"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.dateMsg1'
                          )
                        }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateDate && certificateDateSetting">
                    <v-col cols="12">
                      <!-- <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.date'
                          )
                        }}
                      </p> -->
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedDateFormatted"
                            outlined
                            hide-details
                            persistent-hint
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          no-title
                          @change="setFormatDatePreview(date)"
                          @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateDate">
                    <v-col cols="12">
                      <p class="mb-0">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textSize'
                          )
                        }}
                      </p>
                      <v-slider
                        v-model="dateFontSize"
                        class="align-center"
                        :max="maxFontSize"
                        :min="minFontSize"
                        hide-details
                        @change="drawCertificate"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="dateFontSize"
                            @change="drawCertificate"
                            class="mt-0 pt-0 textfield-custom-number"
                            hide-details
                            outlined
                            type="number"
                          >
                          </v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateDate">
                    <v-col cols="5">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textColor'
                          )
                        }}
                      </p>
                      <v-card
                        class="mx-auto"
                        max-width="400"
                        outlined
                        @click="openDialogDateColor"
                      >
                        <v-list-item two-line>
                          <v-list-item-avatar tile>
                            <v-sheet
                              :color="dateColor"
                              elevation="0"
                              height="100"
                              width="100"
                            ></v-sheet>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-subtitle>{{
                              dateColor
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-col>
                  </v-row>

                  <div v-if="certificateDate">
                    <v-row>
                      <v-col cols="12">
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.textPosition'
                            )
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-slider
                        v-model="dateTop"
                        class="align-center custom-slider ml-3"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="dateTop"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.downUp'
                          )
                        }}
                      </div>
                    </v-row>
                    <v-row class="pt-2">
                      <v-slider
                        v-model="dateLeft"
                        class="align-center custom-slider ml-3"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="dateLeft"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.leftRight'
                          )
                        }}
                      </div>
                    </v-row>
                  </div>
                </v-card-text>
              </v-tab-item>
              <v-tab-item value="expirationDate">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.expDate'
                          )
                        }}
                      </p>
                      <v-radio-group
                        hide-details
                        v-model="certificateDateExp"
                        row
                        @change="drawCertificate"
                      >
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateNo'
                            )
                          "
                          :value="false"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateYes'
                            )
                          "
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateDateExp">
                    <v-col cols="12">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.dateExp'
                          )
                        }}
                      </p>
                      <v-radio-group
                        hide-details
                        v-model="certificateDateExpSetting"
                        row
                        @change="drawCertificate"
                      >
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateExpOptionFlexible'
                            )
                          "
                          :value="false"
                        ></v-radio>
                        <v-radio
                          :label="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateExpOptionFixed'
                            )
                          "
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      certificateDateExp == true &&
                      certificateDateExpSetting == false
                    "
                    no-gutters
                    align="center"
                    class="mt-3"
                  >
                    <!-- <v-col cols="12" class="pb-0"> -->
                    <p class="font-weight-light subtitle-1 mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.certificateStep.dateMsg2'
                        )
                      }}
                    </p>
                    <v-text-field
                      v-model="dateExpAfter"
                      @change="drawCertificate"
                      class="body-1 mx-2 textfield-custom-number"
                      hide-details
                      outlined
                      type="number"
                    >
                    </v-text-field>
                    <div class="body-1 font-weight-light text-custom-title">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.certificateStep.dateMsg3'
                        )
                      }}
                    </div>
                    <!-- </v-col> -->
                  </v-row>

                  <v-row v-if="certificateDateExpSetting == true">
                    <v-col cols="12">
                      <!-- <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.date'
                          )
                        }}
                      </p> -->
                      <v-menu
                        v-model="menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedDateFormatted2"
                            outlined
                            hide-details
                            persistent-hint
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateExp"
                          no-title
                          @change="setFormatDateExpPreview(dateExp)"
                          @input="menu3 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateDateExp" class="mt-5">
                    <v-col cols="12">
                      <p class="mb-0">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textSize'
                          )
                        }}
                      </p>
                      <v-slider
                        v-model="dateExpFontSize"
                        class="align-center"
                        :max="maxFontSize"
                        :min="minFontSize"
                        hide-details
                        @change="drawCertificate"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="dateExpFontSize"
                            @change="drawCertificate"
                            class="mt-0 pt-0 textfield-custom-number"
                            hide-details
                            outlined
                            type="number"
                          >
                          </v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>

                  <v-row v-if="certificateDateExp">
                    <v-col cols="5">
                      <p>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.textColor'
                          )
                        }}
                      </p>
                      <v-card
                        class="mx-auto"
                        max-width="400"
                        outlined
                        @click="openDialogDateExpColor"
                      >
                        <v-list-item two-line>
                          <v-list-item-avatar tile>
                            <v-sheet
                              :color="dateExpColor"
                              elevation="0"
                              height="100"
                              width="100"
                            ></v-sheet>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-subtitle>{{
                              dateExpColor
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-col>
                  </v-row>

                  <div v-if="certificateDateExp">
                    <v-row>
                      <v-col cols="12">
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.textPosition'
                            )
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-slider
                        v-model="dateExpTop"
                        class="align-center custom-slider ml-3"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="dateExpTop"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.downUp'
                          )
                        }}
                      </div>
                    </v-row>
                    <v-row class="pt-2">
                      <v-slider
                        v-model="dateExpLeft"
                        class="align-center custom-slider ml-3"
                        :max="maxPosition"
                        :min="minPosition"
                        hide-details
                        @change="drawCertificate"
                      >
                      </v-slider>
                      <v-text-field
                        class="textfield-custom-number pl-3"
                        outlined
                        type="number"
                        v-model="dateExpLeft"
                        hide-details
                        :max="maxPosition"
                        :min="minPosition"
                        @change="drawCertificate"
                      />
                      <div
                        class="text-custom-title pt-2 pl-5 pr-5 custom-fix-width"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.certificateStep.leftRight'
                          )
                        }}
                      </div>
                    </v-row>
                  </div>
                </v-card-text>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
        <v-col xl="8" lg="7" md="7" cols="7">
          <v-card elevation="0" width="100%" class="pa-5" tile>
            <!-- <div v-if="!imgPreview2" class="image-preview2 border-card"></div> -->
            <!-- <div id="myCanvasCard" style="background-color: #ffffff"> -->
            <!-- <canvas
                id="myCanvas"
                style="border: 1px solid #e0e0e0"
                v-show="imgPreview2 != ''"
              >
              </canvas> -->

            <div
              v-if="!imgPreview2"
              class="d-flex align-center justify-center"
              style="height: 200px; border: 1px solid #e0e0e0"
            >
              <h3>
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.certificateStep.pleaseSelectOrUploadBackground'
                  )
                }}
              </h3>
            </div>
            <!-- </div> -->
            <div v-if="imgPreview2" style="border: 1px solid #e0e0e0">
              <v-img
                class="align-center"
                contain
                :src="imgPreview2"
                height="100%"
                width="100%"
              >
                <v-list-item
                  v-if="certificateStudentName == true"
                  class="layer1"
                  :style="{
                    bottom: `${studentNameTop}%`,
                    left: `${studentNameLeft}%`,
                    fontSize: `${studentFontSize}px`,
                  }"
                >
                  <v-list-item-content>
                    <p class="d-flex mb-0 text-center">
                      <v-sheet
                        justify-content="center"
                        class="d-flex sheet-style mx-auto text-center"
                        height="auto"
                        ><span
                          class="mb-0"
                          :style="{
                            color: `${studentNameColor}`,
                          }"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.studentName'
                            )
                          }}</span
                        ></v-sheet
                      >
                    </p>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  class="layer2"
                  v-if="certificateCourseName == true"
                  :style="{
                    bottom: `${courseNameTop}%`,
                    left: `${courseNameLeft}%`,
                    fontSize: `${courseFontSize}px`,
                  }"
                >
                  <v-list-item-content>
                    <p class="text-center mb-0">
                      <v-sheet
                        class="d-flex sheet-style mx-auto text-center"
                        outlined
                        justify-content="center"
                        height="auto"
                        ><span
                          class="mb-0"
                          :style="{
                            color: `${courseNameColor}`,
                          }"
                          >{{
                            detail.title
                          }}</span
                        ></v-sheet
                      >
                    </p>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  class="layer3"
                  v-if="certificateDate == true"
                  :style="{
                    bottom: `${dateTop}%`,
                    left: `${dateLeft}%`,
                    fontSize: `${dateFontSize}px`,
                  }"
                >
                  <v-list-item-content>
                    <p class="text-center mb-0">
                      <v-sheet
                        class="d-flex sheet-style mx-auto text-center"
                        outlined
                        height="auto"
                        ><span
                          v-if="certificateDateSetting == true"
                          class="mb-0"
                          :style="{
                            color: `${dateColor}`,
                          }"
                        >
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.issuedOn'
                            )
                          }}

                          {{ datePreview }}
                        </span>
                        <span
                          v-if="certificateDateSetting == false"
                          class="mb-0"
                          :style="{
                            color: `${dateColor}`,
                          }"
                        >
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.issuedOn'
                            )
                          }}
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateFormat'
                            )
                          }}
                        </span></v-sheet
                      >
                    </p>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  class="layer4"
                  v-if="certificateDateExp == true"
                  :style="{
                    bottom: `${dateExpTop}%`,
                    left: `${dateExpLeft}%`,
                    fontSize: `${dateExpFontSize}px`,
                  }"
                >
                  <v-list-item-content>
                    <p class="text-center mb-0">
                      <v-sheet
                        class="d-flex sheet-style mx-auto text-center"
                        outlined
                        height="auto"
                        ><span
                          v-if="certificateDateExpSetting == true"
                          class="mb-0"
                          :style="{
                            color: `${dateExpColor}`,
                          }"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.expOn'
                            )
                          }}
                          {{ dateExpPreview }}
                        </span>
                        <span
                          v-if="certificateDateExpSetting == false"
                          class="mb-0"
                          :style="{
                            color: `${dateExpColor}`,
                          }"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.expOn'
                            )
                          }}
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.certificateStep.dateFormat'
                            )
                          }}
                        </span></v-sheet
                      >
                    </p>
                  </v-list-item-content>
                </v-list-item>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <div class="d-flex justify-end">
        <!--
          <v-btn
          @click="onDebug">
            Debug
          </v-btn>
          -->
        <v-btn
          class="pl-5 pr-5 font-weight-light button-primary white--text"
          :disabled="savingCertificate || (certificate && imgPreview2 == '')"
          @click="onUpload"
          elevation="0"
        >
          <v-icon left>mdi-check</v-icon>
          {{
            $vuetify.lang.t('$vuetify.courseManagement.certificateStep.btnSave')
          }}
        </v-btn>
      </div>
    </v-form>

    <v-row justify="center">
      <v-dialog v-model="dialogImgTooBig" max-width="450">
        <v-card>
          <v-card-title class="headline">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogThereisAnError'
              )
            }}
          </v-card-title>

          <v-card-text>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogTheFileIsTooBig'
              )
            }}
            {{ this.imgMaxSize }} MB
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error" text @click="dialogImgTooBig = false">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogBtnOK'
              )
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogImgDoesNotSupport" max-width="450">
        <v-card>
          <v-card-title class="headline">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogThereisAnError'
              )
            }}
          </v-card-title>

          <v-card-text>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogTheFileNotJpgOrPng'
              )
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1"
              text
              @click="dialogImgDoesNotSupport = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.certificateStep.dialogBtnOK'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogUpdateFail" max-width="450">
        <v-card>
          <v-card-title class="headline">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogThereisAnError'
              )
            }}
          </v-card-title>

          <v-card-text>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogUpdateFail'
              )
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1" text @click="dialogAddFail = false">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.certificateStep.dialogBtnOK'
              )
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.certificateStep.dialogUpdateSuccessTitle'
            )
          }}
        </v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.certificateStep.dialogUpdateSuccessText'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.certificateStep.dialogBtnOK'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog persistent v-model="dialogStudentColor" max-width="350">
        <v-card>
          <v-card-text class="pa-5">
            <v-color-picker
              v-model="pickStudentColor"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click="closeDialogStudentColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogCancel') }}</v-btn
            >
            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="selectStudentColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogConfirm') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogCourseColor" max-width="350">
        <v-card>
          <v-card-text class="pa-5">
            <v-color-picker
              v-model="pickCourseColor"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click="closeDialogCourseColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogCancel') }}</v-btn
            >
            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="selectCourseColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogConfirm') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogDateColor" max-width="350">
        <v-card>
          <v-card-text class="pa-5">
            <v-color-picker
              v-model="pickDateColor"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click="closeDialogDateColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogCancel') }}</v-btn
            >
            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="selectDateColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogConfirm') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogDateExpColor" max-width="350">
        <v-card>
          <v-card-text class="pa-5">
            <v-color-picker
              v-model="pickDateExpColor"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click="closeDialogDateExpColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogCancel') }}</v-btn
            >
            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="selectDateExpColor()"
              >{{ $vuetify.lang.t('$vuetify.courseManagement.certificateStep.dialogConfirm') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { getCourseById, updateCourse } from '@/service/course/course';
// import { uploadImage } from "@/service/upload/upload";
import { headersWithTokenForImage, domain } from '@/service/configApi';
import axios from 'axios';
export default {
  data: function () {
    return {
      //edit
      isEdit: false,
      courseID: '',
      detail: {},
      dialogSuccess: false,
      dialogUpdateFail: false,
      dialogImgTooBig: false,
      dialogImgDoesNotSupport: false,
      imgMaxSize: 3, //MB
      imgPreview2: '',
      imageReady2: false,
      imageFile2: null,
      certificate: false,
      percentCertificate: 100,
      valid: true,
      menu2: false,
      menu3: false,
      imageRules: [
        (v) =>
          !v ||
          v.size < 20000000 ||
          this.$vuetify.lang.t('$vuetify.plsChooseUnder20MB'),
      ],

      imgBool2: false,

      setPercentTop: 0,
      setPercentLeft: 0,

      certificateStudentName: true,
      certificateCourseName: false,
      certificateDate: false,
      certificateDateExp: false,
      certificateDateSetting: false,
      certificateDateExpSetting: false,
      certificateDateExpiration: false,
      dateExpAfter: 1,
      dateTimeStamp: null,
      dateExpTimeStamp: null,
      imgUpload: null,
      dateTimePreview: new Date(),

      colorOption: ['#000000', '#FFFFFF', '#FF0000', '#00FF00', '#0000FF'],

      studentFontSize: 20,
      studentNameTop: 0,
      studentNameLeft: 0,
      studentNameColor: '#000000FF',
      pickStudentColor: '000000FF',
      studentSelectedColorOptions: [false, false, false, false, false],

      courseFontSize: 20,
      courseNameTop: 0,
      courseNameLeft: 0,
      courseNameColor: '#000000FF',
      pickCourseColor: '#000000FF',
      courseSelectedColorOptions: [false, false, false, false, false],

      defaultHexColor: '#000000FF',

      dateFontSize: 20,
      date: new Date().toISOString().substr(0, 10),
      dateTop: 0,
      dateLeft: 0,
      dateColor: '#000000FF',
      pickDateColor: '#000000FF',
      dateSelectedColorOptions: [false, false, false, false, false],

      dateExpFontSize: 20,
      dateExp: new Date().toISOString().substr(0, 10),
      dateExpTop: 0,
      dateExpLeft: 0,
      dateExpColor: '#000000FF',
      pickDateExpColor: '#000000FF',
      dateExpSelectedColorOptions: [false, false, false, false, false],

      params: {},
      dialogStudentColor: false,
      dialogCourseColor: false,
      dialogDateColor: false,
      dialogDateExpColor: false,

      certificateSelectedItem: 'background',
      certificateStyleItems: [
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.certificateStep.background'
        ),
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.certificateStep.studentName'
        ),
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.certificateStep.courseName'
        ),
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.certificateStep.issuedDate'
        ),
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.certificateStep.expDate'
        ),
      ],

      myCanvasCard: null,
      myCanvas: null,

      minFontSize: 0,
      maxFontSize: 100,
      minPosition: -100,
      maxPosition: 100,
      backgroundTemplateList: [],
      backgroundTemplate: [
        'https://s3-amr.deknerd.com/template/certificates/certificate1.png',
        'https://s3-amr.deknerd.com/template/certificates/certificate2.png',
        'https://s3-amr.deknerd.com/template/certificates/certificate3.png',
        'https://s3-amr.deknerd.com/template/certificates/certificate4.png',
        'https://s3-amr.deknerd.com/template/certificates/certificate5.png',
        'https://s3-amr.deknerd.com/template/certificates/certificate6.png',
        'https://s3-amr.deknerd.com/template/certificates/certificate7.png',
      ],

      savingCertificate: false,
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      colorPickerModes: ['hsla', 'rgba', 'hexa'],
      mode: 'rgba',
    };
  },
  props: {
    fontsize: {
      type: Number,
      default: 0,
    },
    marginbottom: {
      type: Number,
      default: 0,
    },
    marginleft: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedDateFormatted2() {
      return this.formatDate(this.dateExp);
    },

    studentNameStyleFont() {
      return {
        fontsize: `${this.studentFontSize}px`,
      };
    },
    studentNameStyle() {
      return {
        marginbottom: `${this.studentNameTop}%`,
        marginleft: `${this.studentNameLeft}%`,
      };
    },
    courseNameStyleFont() {
      return {
        fontsize: `${this.courseFontSize}px`,
      };
    },
    courseNameStyle() {
      return {
        marginbottom: `${this.courseNameTop}%`,
        marginleft: `${this.courseNameLeft}%`,
      };
    },
    dateStyleFont() {
      return {
        fontsize: `${this.dateFontSize}px`,
      };
    },
    dateStyle() {
      return {
        marginbottom: `${this.dateTop}%`,
        marginleft: `${this.dateLeft}%`,
      };
    },
    dateExpStyleFont() {
      return {
        fontsize: `${this.dateExpFontSize}px`,
      };
    },
    dateExpStyle() {
      return {
        marginbottom: `${this.dateExpTop}%`,
        marginleft: `${this.dateExpLeft}%`,
      };
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    dateExp(val) {
      this.dateFormatted2 = this.formatDate(this.dateExp);
    },
  },
  methods: {
    checkMinPercentScore() {
      if (this.percentCertificate < 0) this.percentCertificate = 0;
      if (this.percentCertificate > 100) this.percentCertificate = 100;
      if (this.percentCertificate == '') this.percentCertificate = 0;
    },
    checkDate() {
      if (this.dateExp == null)
        this.dateExp = new Date().toISOString().substr(0, 10);
    },
    checkStudentFontSize() {
      this.studentNameStyleFont();
    },
    checkStudentNameTop() {
      this.studentNameStyle();
    },
    checkStudentNameLeft() {
      this.studentNameStyle();
    },

    checkCourseFontSize() {
      this.courseNameStyleFont();
    },
    checkCourseNameTop() {
      this.courseNameStyle();
    },
    checkCourseNameLeft() {
      this.courseNameStyle();
    },

    checkDateFontSize() {
      this.dateStyleFont();
    },
    checkDateTop() {
      this.dateStyle();
    },
    checkDateLeft() {
      this.dateStyle();
    },

    checkDateExpFontSize() {
      this.dateExpStyleFont();
    },
    checkDateExpTop() {
      this.dateExpStyle();
    },
    checkDateExpLeft() {
      this.dateExpStyle();
    },
    async preview2(event) {
      let file = event.target.files[0];

      const dataURItoBlob = (dataURI) => {
        const bytes =
          dataURI.split(',')[0].indexOf('base64') >= 0
            ? atob(dataURI.split(',')[1])
            : unescape(dataURI.split(',')[1]);
        const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const max = bytes.length;
        const ia = new Uint8Array(max);
        for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
      };

      const resizeImage = ({ file }) => {
        const reader = new FileReader();
        const image = new Image();
        const canvas = document.createElement('canvas');

        const resize = () => {
          let width = 1600;
          let height = 1100;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(image, 0, 0, width, height);

          const dataUrl = canvas.toDataURL('image/jpeg');

          return dataURItoBlob(dataUrl);
        };

        return new Promise((ok, no) => {
          if (!file.type.match(/image.*/)) {
            no(new Error('Not an image'));
            return;
          }

          reader.onload = (readerEvent) => {
            image.onload = () => ok(resize());
            image.src = readerEvent.target.result;
          };

          reader.readAsDataURL(file);
        });
      };
      resizeImage({ file: file })
        .then((resizedImage) => {
          this.imgPreview2 = URL.createObjectURL(resizedImage);
        })
        .catch((err) => {
          console.error(err);
        });

      if (file.type == 'image/png' || file.type == 'image/jpeg') {
        if (file.size / 1024 / 1024 < this.imgMaxSize) {
          this.imageFile2 = file;
          // this.imgPreview2 = await URL.createObjectURL(file);
          this.imageName2 = file.name;
          if (this.imgPreview2) {
            this.imageReady2 = true;
            this.drawCertificate();
          }
          this.imgBool2 = true;
        } else {
          this.dialogImgTooBig = true;
        }
      } else {
        this.dialogImgDoesNotSupport = true;
      }
    },

    refreshPage() {
      this.initialize();
    },

    async initialize() {
      this.fullFormatDate();
      this.courseID = this.$route.query.id;

      if (this.courseID != null && this.courseID != undefined) {
        let params = {
          id: this.courseID,
        };

        await this.getCourseDetail(params);
        this.isEdit = true;
      } else {
        this.setOwner = false;
      }
    },
    setFormatDatePreview(dateString) {
      console.log(dateString);
      this.dateTimePreview = new Date(dateString);
      this.datePreview = this.fullFormatDate();
    },
    setFormatDateExpPreview(dateString) {
      console.log(dateString);
      this.dateTimePreview = new Date(dateString);
      this.dateExpPreview = this.fullFormatDate();
    },
    fullFormatDate() {
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      // this.datePreview = new Date();
      // console.log(this.dateTimePreview);
      // console.log(this.dateExp);
      const month = monthNames[this.dateTimePreview.getMonth()];
      const day = String(this.dateTimePreview.getDate()).padStart(2, '0');
      const year = this.dateTimePreview.getFullYear();
      const fullDate = day + ' ' + month + ' ' + year;

      return fullDate;
    },
    async onUpload() {
      let isValidForm = true;

      if (isValidForm) {
        this.savingCertificate = true;
        let course;
        if (this.courseID != null) {
          if (this.imageFile2 != null) {
            await this.uploadImg2(this.imageFile2);
          }

          course = await this.updateCourse(this.courseID);
        }

        this.savingCertificate = false;

        if (course != false) {
          this.dialogSuccess = true;
        }
      }
    },
    async uploadImg2(file) {
      this.showUploadPercent = true;
      let formData = new FormData();

      const dataURItoBlob = (dataURI) => {
        const bytes =
          dataURI.split(',')[0].indexOf('base64') >= 0
            ? atob(dataURI.split(',')[1])
            : unescape(dataURI.split(',')[1]);
        const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const max = bytes.length;
        const ia = new Uint8Array(max);
        for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
      };

      const resizeImage = ({ file }) => {
        const reader = new FileReader();
        const image = new Image();
        const canvas = document.createElement('canvas');

        const resize = () => {
          let width = 1600;
          let height = 1100;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(image, 0, 0, width, height);

          const dataUrl = canvas.toDataURL('image/jpeg');

          return dataUrl;
        };

        return new Promise((ok, no) => {
          if (!file.type.match(/image.*/)) {
            no(new Error('Not an image'));
            return;
          }

          reader.onload = (readerEvent) => {
            image.onload = () => ok(resize());
            image.src = readerEvent.target.result;
          };

          reader.readAsDataURL(file);
        });
      };
      this.imgUpload = await resizeImage({ file: file });

      formData.append('fileupload', file);
      formData.append('title', file.name);
      formData.append('imageBinary', this.imgUpload);
      console.log(this.imgUpload);
      console.log(formData);
      await axios
        .post(`${domain}/uploadfile/public/image/course`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.imgPreview2 = response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);
        });
    },
    async updateCourse(courseID) {
      let status = null;
      let dt = new Date(this.date).toISOString();
      let dtExp = new Date(this.dateExp).toISOString();

      this.dateTimeStamp = new Date(dt).getTime();
      this.dateExpTimeStamp = new Date(dtExp).getTime();

      let dateExpTimeStamp = this.dateExpTimeStamp;
      let dateExpMonth = this.dateExpAfter * 2629743 * 1000;
      console.log(this.dateExpTimeStamp + dateExpMonth);
      let valueData = {
        ...this.detail,
        id: courseID,
        certificate: this.certificate,
        percentCertificate: this.percentCertificate,
        urlCertificateTemplate: this.imgPreview2,

        styleCertificate: {
          studentName: {
            certificateStudentName: this.certificateStudentName,
            studentFontSize: this.studentFontSize,
            studentNameTop: this.studentNameTop,
            studentNameLeft: this.studentNameLeft,
            studentNameColor: this.studentNameColor,
          },
          courseName: {
            certificateCourseName: this.certificateCourseName,
            courseFontSize:
              this.certificateCourseName == true ? this.courseFontSize : 20,
            courseNameTop:
              this.certificateCourseName == true ? this.courseNameTop : 0,
            courseNameLeft:
              this.certificateCourseName == true ? this.courseNameLeft : 0,
            courseNameColor:
              this.certificateCourseName == true
                ? this.courseNameColor
                : '#000000FF',
          },
          date: {
            certificateDate: this.certificateDate,
            certificateDateSetting:
              this.certificateDate == true
                ? this.certificateDateSetting
                : false,
            dateTimeStamp:
              this.certificateDate == true ? this.dateTimeStamp : 0,
            dateFontSize: this.certificateDate == true ? this.dateFontSize : 20,
            date:
              this.certificateDate == true
                ? this.date
                : new Date().toISOString().substr(0, 10),
            dateTop: this.certificateDate == true ? this.dateTop : 0,
            dateLeft: this.certificateDate == true ? this.dateLeft : 0,
            dateColor:
              this.certificateDate == true ? this.dateColor : '#000000FF',
          },
          dateExp: {
            certificateDateExp: this.certificateDateExp,
            certificateDateExpSetting:
              this.certificateDateExp == true
                ? this.certificateDateExpSetting
                : false,
            dateExpTimeStamp:
              this.certificateDateExp == true ? dateExpTimeStamp : 0,
            dateExpAfter:
              this.certificateDateExpSetting == false ? dateExpMonth : 0,
            dateExpFontSize:
              this.certificateDateExp == true ? this.dateExpFontSize : 20,
            dateExp:
              this.certificateDateExp == true
                ? this.dateExp
                : new Date().toISOString().substr(0, 10),
            dateExpTop: this.certificateDateExp == true ? this.dateExpTop : 0,
            dateExpLeft: this.certificateDateExp == true ? this.dateExpLeft : 0,
            dateExpColor:
              this.certificateDateExp == true ? this.dateExpColor : '#000000FF',
          },
        },
      };

      status = await updateCourse(valueData);

      if (status.code == 403) {
        this.dialogUpdateFail = true; //กรณี error อื่น
        return false;
      } else {
        return status;
      }
    },
    async getCourseDetail(params) {
      let detail = await getCourseById(params);
      console.log(detail)
      this.detail = detail;
      this.imgURLCertificate = detail.urlCertificateTemplate;
      this.certificate = detail.certificate;
      this.percentCertificate = detail.percentCertificate;
      this.imgPreview2 = detail.urlCertificateTemplate;
      this.imageReady2 = true;
      detail.urlCertificateTemplate
        ? this.backgroundTemplateList.push({
            image: detail.urlCertificateTemplate,
          })
        : (this.backgroundTemplateList = []);
      this.backgroundTemplate.forEach((template) => {
        this.backgroundTemplateList.push({
          image: template,
          use: false,
        });
      });

      this.certificateStudentName =
        detail.styleCertificate.studentName.certificateStudentName;
      this.certificateCourseName =
        detail.styleCertificate.courseName.certificateCourseName;
      this.certificateDate = detail.styleCertificate.date.certificateDate;
      this.certificateDateSetting = detail.styleCertificate.date
        .certificateDateSetting
        ? detail.styleCertificate.date.certificateDateSetting
        : false;
      this.certificateDateExp = detail.styleCertificate.dateExp
        ? detail.styleCertificate.dateExp.certificateDateExp
        : false;
      this.certificateDateExpSetting = detail.styleCertificate.dateExp
        ? detail.styleCertificate.dateExp.certificateDateExpSetting
        : false;

      this.studentFontSize =
        detail.styleCertificate.studentName.studentFontSize;
      this.studentNameTop = detail.styleCertificate.studentName.studentNameTop;
      this.studentNameLeft =
        detail.styleCertificate.studentName.studentNameLeft;
      this.studentNameColor =
        detail.styleCertificate.studentName.studentNameColor;

      this.courseFontSize = detail.styleCertificate.courseName.courseFontSize;
      this.courseNameTop = detail.styleCertificate.courseName.courseNameTop;
      this.courseNameLeft = detail.styleCertificate.courseName.courseNameLeft;
      this.courseNameColor = detail.styleCertificate.courseName.courseNameColor;

      this.date = detail.styleCertificate.date.date;
      if (this.date == '') {
        this.date = new Date().toISOString().substr(0, 10);
      }
      this.dateExp = detail.styleCertificate.dateExp.dateExp;
      if (this.dateExp == '') {
        this.dateExp = new Date().toISOString().substr(0, 10);
      }
      // this.dateTimeStamp = detail.styleCertificate.date.dateTimeStamp;
      // this.dateExpAfter = detail.styleCertificate.dateExp.dateExpAfter;
      // let month = new Date(
      //   detail.styleCertificate.dateExp.dateExpAfter
      // ).getMonth();
      let month = detail.styleCertificate.dateExp.dateExpAfter / 2629743 / 1000;
      console.log(month);
      this.dateExpAfter = month;

      this.datePreview = detail.styleCertificate.date.date;
      this.setFormatDatePreview(this.datePreview);
      this.dateFontSize = detail.styleCertificate.date.dateFontSize;
      this.dateTop = detail.styleCertificate.date.dateTop;
      this.dateLeft = detail.styleCertificate.date.dateLeft;
      this.dateColor = detail.styleCertificate.date.dateColor;
      this.dateExpPreview = detail.styleCertificate.dateExp.dateExp;
      this.setFormatDateExpPreview(this.dateExpPreview);
      this.dateExpFontSize = detail.styleCertificate.dateExp.dateExpFontSize;
      this.dateExpTop = detail.styleCertificate.dateExp.dateExpTop;
      this.dateExpLeft = detail.styleCertificate.dateExp.dateExpLeft;
      this.dateExpColor = detail.styleCertificate.dateExp.dateExpColor;
    },
    openDialogStudentColor() {
      this.dialogStudentColor = true;
      if (this.studentNameColor) {
        this.pickStudentColor = this.studentNameColor;
      }
    },
    closeDialogStudentColor() {
      this.dialogStudentColor = false;
    },
    selectStudentColor() {
      this.studentNameColor = this.pickStudentColor;

      //Reset check mark in colors
      for (var i = 0; i < this.studentSelectedColorOptions.length; i++) {
        this.$set(this.studentSelectedColorOptions, i, false);
      }

      //check mark the custom color
      this.$set(this.studentSelectedColorOptions, 5, true);

      this.closeDialogStudentColor();
      this.drawCertificate();
    },
    openDialogCourseColor() {
      this.dialogCourseColor = true;
      if (this.courseNameColor) {
        this.pickCourseColor = this.courseNameColor;
      }
    },
    closeDialogCourseColor() {
      this.dialogCourseColor = false;
    },
    selectCourseColor() {
      this.courseNameColor = this.pickCourseColor;

      //Reset check mark in colors
      for (var i = 0; i < this.courseSelectedColorOptions.length; i++) {
        this.$set(this.courseSelectedColorOptions, i, false);
      }

      //check mark the custom color
      this.$set(this.courseSelectedColorOptions, 5, true);
      this.closeDialogCourseColor();
      this.drawCertificate();
    },
    openDialogDateColor() {
      this.dialogDateColor = true;
      if (this.dateColor) {
        this.pickDateColor = this.dateColor;
      }
    },
    openDialogDateExpColor() {
      this.dialogDateExpColor = true;
      if (this.dateExpColor) {
        this.pickDateExpColor = this.dateExpColor;
      }
    },
    closeDialogDateColor() {
      this.dialogDateColor = false;
    },
    closeDialogDateExpColor() {
      this.dialogDateExpColor = false;
    },
    selectDateColor() {
      this.dateColor = this.pickDateColor;

      //Reset check mark in colors
      for (var i = 0; i < this.dateSelectedColorOptions.length; i++) {
        this.$set(this.dateSelectedColorOptions, i, false);
      }

      //check mark the custom color
      this.$set(this.dateSelectedColorOptions, 5, true);
      this.closeDialogDateColor();
      this.drawCertificate();
    },

    selectDateExpColor() {
      this.dateExpColor = this.pickDateExpColor;

      //Reset check mark in colors
      for (var i = 0; i < this.dateExpSelectedColorOptions.length; i++) {
        this.$set(this.dateExpSelectedColorOptions, i, false);
      }

      //check mark the custom color
      this.$set(this.dateExpSelectedColorOptions, 5, true);
      this.closeDialogDateExpColor();
      this.drawCertificate();
    },
    setBackground(item, index) {
      console.log(item, index);
      this.imageFile2 = null;
      this.imgPreview2 = item.image;
      this.imageReady2 = true;
      this.backgroundTemplateList[index].use = item.use;
      //this.certificateSelectedItem = 1; //move to next tab
      this.drawCertificate();
    },
    colorSelected(group, index) {
      var i = 0;
      switch (group) {
        //student
        case 0:
          for (i = 0; i < this.studentSelectedColorOptions.length; i++) {
            this.$set(this.studentSelectedColorOptions, i, false);
          }

          this.studentNameColor = this.colorOption[index];

          this.$set(this.studentSelectedColorOptions, index, true);
          break;

        //course
        case 1:
          for (i = 0; i < this.courseSelectedColorOptions.length; i++) {
            this.$set(this.courseSelectedColorOptions, i, false);
          }

          this.courseNameColor = this.colorOption[index];

          this.$set(this.courseSelectedColorOptions, index, true);
          break;

        //date
        case 2:
          for (i = 0; i < this.dateSelectedColorOptions.length; i++) {
            this.$set(this.dateSelectedColorOptions, i, false);
          }

          this.dateColor = this.colorOption[index];

          this.$set(this.dateSelectedColorOptions, index, true);
          break;

        //date
        case 3:
          for (i = 0; i < this.dateExpSelectedColorOptions.length; i++) {
            this.$set(this.dateExpSelectedColorOptions, i, false);
          }

          this.dateExpColor = this.colorOption[index];

          this.$set(this.dateExpSelectedColorOptions, index, true);
          break;
      }
      this.drawCertificate();
    },
    /*
    onDebug(){
      //this.$set(this.certificateSelectedItem, 2);
      //this.certificateSelectedItem = 0;
    },
    */
    drawCertificate() {
      var myCanvasCard = document.getElementById('myCanvasCard');
      var myCanvas = document.getElementById('myCanvas');

      var studentFontSize = this.studentFontSize;
      var courseFontSize = this.courseFontSize;
      var dateFontSize = this.dateFontSize;
      var dateExpFontSize = this.dateExpFontSize;

      var studentNameColor = this.studentNameColor;
      var courseNameColor = this.courseNameColor;
      var dateColor = this.dateColor;
      var dateExpColor = this.dateExpColor;

      var courseNameTop = this.courseNameTop;
      var courseNameLeft = this.courseNameLeft;
      var studentNameTop = this.studentNameTop;
      var studentNameLeft = this.studentNameLeft;
      var dateTop = this.dateTop;
      var dateLeft = this.dateLeft;
      var dateExpTop = this.dateExpTop;
      var dateExpLeft = this.dateExpLeft;

      var certificateStudentName = this.certificateStudentName;
      var certificateCourseName = this.certificateCourseName;
      var certificateDate = this.certificateDate;
      var certificateDateExp = this.certificateDateExp;

      if (this.certificateDateSetting == false) {
        this.menu2 = false;
      }
      if (this.certificateDateExpSetting == false) {
        this.menu3 = false;
      }
      if (this.certificateDateExpSetting == true) {
        this.dateExpAfter = 1;
      }

      console.log(this.imgPreview2);
      console.log(myCanvasCard.offsetWidth);
      if (this.imgPreview2 == '') {
        //No image selected
        var ratio = 600 / 800; //fake image size to render certificate

        var canvasWidth = myCanvasCard.offsetWidth;
        var canvasHeight = myCanvasCard.offsetWidth * ratio;

        var scale = canvasWidth / 800;

        var midX = canvasWidth / 2;
        var midY = canvasHeight / 2;

        var ctx = myCanvas.getContext('2d');

        ctx.canvas.width = canvasWidth;
        ctx.canvas.height = canvasHeight;

        ctx.textAlign = 'center';

        if (certificateCourseName) {
          ctx.font = courseFontSize * scale + 'px Roboto, Sarabun';
          ctx.fillStyle = courseNameColor;
          ctx.fillText(
            'ชื่อคอร์ส',
            midX + midX * (courseNameLeft / 100.0),
            midY - midY * (courseNameTop / 100.0)
          );
        }

        if (certificateStudentName) {
          ctx.font = studentFontSize * scale + 'px Roboto, Sarabun';
          ctx.fillStyle = studentNameColor;
          ctx.fillText(
            'ชื่อนักเรียน นามสกุล',
            midX + midX * (studentNameLeft / 100.0),
            midY - midY * (studentNameTop / 100.0)
          );
        }

        if (certificateDate) {
          ctx.font = dateFontSize * scale + 'px Roboto, Sarabun';
          ctx.fillStyle = dateColor;
          ctx.fillText(
            'YYYY-MM-DD',
            midX + midX * (dateLeft / 100.0),
            midY - midY * (dateTop / 100.0)
          );
        }

        if (certificateDateExp) {
          ctx.font = dateExpFontSize * scale + 'px Roboto, Sarabun';
          ctx.fillStyle = dateExpColor;
          ctx.fillText(
            'YYYY-MM-DD',
            midX + midX * (dateExpLeft / 100.0),
            midY - midY * (dateExpTop / 100.0)
          );
        }
      } else {
        var base_image = new Image();
        base_image.src = this.imgPreview2;
        base_image.onload = function () {
          console.log('Hello Image');
          //need to be in onload to get width and height;
          var ratio = base_image.height / base_image.width;

          var canvasWidth = myCanvasCard.offsetWidth;
          var canvasHeight = myCanvasCard.offsetWidth * ratio;

          var scale = canvasWidth / base_image.width;

          var midX = canvasWidth / 2;
          var midY = canvasHeight / 2;

          var ctx = myCanvas.getContext('2d');

          ctx.canvas.width = canvasWidth;
          ctx.canvas.height = canvasHeight;

          ctx.drawImage(base_image, 0, 0, canvasWidth, canvasHeight);
          ctx.textAlign = 'center';

          if (certificateCourseName) {
            ctx.font = courseFontSize * scale + 'px Roboto, Sarabun';
            ctx.fillStyle = courseNameColor;
            ctx.fillText(
              'ชื่อคอร์ส',
              midX + midX * (courseNameLeft / 100.0),
              midY - midY * (courseNameTop / 100.0)
            );
          }

          if (certificateStudentName) {
            ctx.font = studentFontSize * scale + 'px Roboto, Sarabun';
            ctx.fillStyle = studentNameColor;
            ctx.fillText(
              'ชื่อนักเรียน นามสกุล',
              midX + midX * (studentNameLeft / 100.0),
              midY - midY * (studentNameTop / 100.0)
            );
          }

          if (certificateDate) {
            ctx.font = dateFontSize * scale + 'px Roboto, Sarabun';
            ctx.fillStyle = dateColor;
            ctx.fillText(
              'YYYY-MM-DD',
              midX + midX * (dateLeft / 100.0),
              midY - midY * (dateTop / 100.0)
            );
          }

          if (certificateDateExp) {
            ctx.font = dateExpFontSize * scale + 'px Roboto, Sarabun';
            ctx.fillStyle = dateExpColor;
            ctx.fillText(
              'YYYY-MM-DD',
              midX + midX * (dateExpLeft / 100.0),
              midY - midY * (dateExpTop / 100.0)
            );
          }
        };
      }
    },
    onWindowResize() {
      this.drawCertificate();
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
  created() {
    window.addEventListener('resize', this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  async mounted() {
    await this.initialize();
    console.log('Certificate Mounted');
    this.drawCertificate();
  },
};
</script>

<style scoped>
/* .v-tabs-slider-wrapper {
  height: 2px !important;
} */
.card-style {
  margin-bottom: 25%;
}
.sheet-style {
  justify-content: center;
  background: content-box;
  border: none;
}
.box {
  width: 100%;
  height: 100%;
  opacity: 0.9;
  position: absolute;
}
.layer1 {
  z-index: 1;
}
.layer2 {
  z-index: 2;
}
.layer3 {
  z-index: 3;
}
.layer4 {
  z-index: 4;
}
.layer1,
.layer2,
.layer3,
.layer4 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 200px !important;
}

.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 10px;
  font-size: 16px;
  width: 200px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
.uppercast-unset {
  text-transform: unset;
}

.nowrap-overflow {
  flex-wrap: nowrap;
  overflow-x: auto;
}

.textfield-custom-number {
  min-width: 85px;
  max-width: 85px;
}

.custom-fix-width {
  min-width: 110px;
  max-width: 110px;
}

/* .v-slider__thumb:before {
  content: '';
  color: white;
  width: 36px;
  height: 36px;
  background: currentColor;
  left: -12px;
  top: -12px;
  -webkit-transform: scale(0.1);
  transform: scale(0.2);
  pointer-events: none;
} */

/* .v-tab {
  border-style: solid;
  border-width: 2px;
  border-color: #eeeeef;
} */

.centerContainer {
  position: relative;
}

.centerDiv {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.border-card {
  border: 1px dashed #80808040 !important;
  /* -webkit-box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
  /* box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
}
.image-preview {
  height: 170px;
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
  width: 220px !important;
}
.image-preview2 {
  height: 450px;
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
  /* width: 240px !important; */
  width: 100% !important;
}
</style>

<style scoped lang="scss">
.custom-slider {
  // .v-slider__thumb:before {
  //   content: '';
  //   color: white;
  //   width: 36px;
  //   height: 36px;
  //   background: currentColor;
  //   opacity: 1;
  //   left: -12px;
  //   top: -12px;
  //   -webkit-transform: scale(0.2);
  //   transform: scale(0.2);
  //   pointer-events: none;
  // }

  // .v-slider__thumb-container--active .v-slider__thumb:before {
  //   color: #91d5ff;
  //   transform: scale(0.8) !important;
  // }
  // .v-slider__thumb-container:hover .v-slider__thumb:before {
  //   color: #91d5ff;
  //   transform: scale(0.8) !important;
  // }

  // .theme--light.v-slider .v-slider__thumb,
  // .theme--light.v-slider .v-slider__track-background,
  // .v-slider__track-fill {
  //   background: #91d5ff !important;
  // }

  // .v-slider__track-background.primary.lighten-3 {
  //   background-color: rgba(0, 0, 0, 0.04) !important;
  // }

  .primary--text {
    color: red !important;
    caret-color: blue !important;
  }

  // .v-slider--horizontal .v-slider__track-container {
  //   width: 100%;
  //   height: 6px;
  //   left: 0;
  //   top: 50%;
  //   -webkit-transform: translateY(-50%);
  //   transform: translateY(-50%);
  // }
}

//Keep showing up down arrows in number input
// input[type='number']::-webkit-inner-spin-button,
// input[type='number']::-webkit-outer-spin-button {
//   opacity: 1;
// }
</style>
